var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7565 9.45057H19.722V0.5H0.5V35.5H34.6193V9.45057H19.7565ZM12.5339 33.0972V24.127H8.08898V33.0972H2.90775H2.9027V2.90297H17.3193V11.8535H32.2163V33.0973H12.583H12.5339V33.0972Z",
    fill: "#F75586"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10645 8.18945V12.7299V12.7439V12.7546H8.74949V8.18945H6.10645Z",
    fill: "#F75586"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.873 8.18945V12.7299V12.7439V12.7546H14.5161V8.18945H11.873Z",
    fill: "#F75586"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10645 20.3381V20.3519V20.3629H8.74949V15.7979H6.10645V20.3381Z",
    fill: "#F75586"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.873 20.3381V20.3519V20.3629H14.5161V15.7979H11.873V20.3381Z",
    fill: "#F75586"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2031 20.3381V20.3519V20.3629H22.8462V15.7979H20.2031V20.3381Z",
    fill: "#F75586"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9697 20.3381V20.3519V20.3629H28.6128V15.7979H25.9697V20.3381Z",
    fill: "#F75586"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2141 23.4072H20.2031V27.9475V27.9614V27.9723H22.8462V23.4072H20.2221H20.2141Z",
    fill: "#F75586"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9807 23.4072H25.9697V27.9475V27.9614V27.9723H28.6128V23.4072H25.9887H25.9807Z",
    fill: "#F75586"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomResearch);
export default __webpack_public_path__ + "static/media/roomResearch.945e70d3d0d146033faba80fa392df00.svg";
export { ForwardRef as ReactComponent };